// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1zHxx","title":"Info_title__2WLIk","selects":"Info_selects__9MPqv","requiredAsterisk":"Info_requiredAsterisk__3Qaqv"};